/* MirJo gift boxes: cart presentation and storefront checkout integrity. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.install(root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var GROUP = '_mirjo_giftbox_group';
  var ROLE = '_mirjo_giftbox_role';
  var COUNT = '_mirjo_giftbox_count';

  function properties(item) {
    return item && item.properties && !Array.isArray(item.properties) ? item.properties : {};
  }

  function groupValue(item) {
    var value = properties(item)[GROUP];
    return typeof value === 'string' && value.trim() ? value : null;
  }

  function parentKey(item) {
    return item && item.parent_relationship && item.parent_relationship.parent_key;
  }

  /** Pure validation; normal merchandise and existing gift-card properties are ignored. */
  function validateCart(cart, options) {
    options = options || {};
    var productId = String(options.packagingProductId || '');
    var variantId = String(options.packagingVariantId || '');
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var packagingByKey = new Map();
    var groups = new Map();
    var related = [];

    function isPackagingProduct(item) {
      return !!((productId && String(item.product_id) === productId) ||
        (variantId && String(item.variant_id || item.id) === variantId));
    }

    items.forEach(function (item) {
      if (properties(item)[ROLE] === 'packaging' || isPackagingProduct(item)) {
        packagingByKey.set(item.key, item);
      }
    });

    items.forEach(function (item, index) {
      var props = properties(item);
      var linkedParent = packagingByKey.get(parentKey(item));
      if (!(GROUP in props) && !(ROLE in props) && !(COUNT in props) && !isPackagingProduct(item) && !linkedParent) return;
      var value = groupValue(item);
      var inferredValue = linkedParent && groupValue(linkedParent);
      var id = value || inferredValue
        ? 'group:' + (value || inferredValue)
        : 'line:' + ((linkedParent && linkedParent.key) || item.key || index);
      if (!groups.has(id)) groups.set(id, { id: id, value: value || inferredValue || null, records: [], issues: [] });
      var record = { item: item, index: index, role: props[ROLE], packagingProduct: isPackagingProduct(item) };
      groups.get(id).records.push(record);
      related.push(record);
    });

    var result = Array.from(groups.values()).map(function (group, number) {
      function issue(code) { if (group.issues.indexOf(code) < 0) group.issues.push(code); }
      var parents = group.records.filter(function (record) { return record.role === 'packaging'; });
      var samples = group.records.filter(function (record) { return record.role === 'sample'; });
      var parent = parents.length === 1 ? parents[0].item : null;
      var countText = parent && properties(parent)[COUNT];
      var titleText = parent && properties(parent)._mirjo_giftbox_title;
      group.number = number + 1;
      group.parent = parent;
      group.expectedCount = countText === '3' || countText === '4' ? Number(countText) : null;
      group.sampleCount = 0;
      if (parents.length !== 1) issue('parent_count');
      if (!group.value) issue('missing_group');
      if (parent && parent.quantity !== 1) issue('packaging_quantity');
      if (parent && !group.expectedCount) issue('selection_count');
      if (parent && (typeof titleText !== 'string' || !titleText.trim())) issue('title_required');
      if (parent && parent.parent_relationship) issue('nested_packaging');
      group.records.forEach(function (record) {
        var item = record.item;
        if (groupValue(item) !== group.value || !group.value) issue('missing_group');
        if (record.role !== 'sample' && record.role !== 'packaging') issue('unknown_role');
        if (record.packagingProduct && record.role !== 'packaging') issue('packaging_role');
        if (record.role === 'packaging' && (productId || variantId) && !record.packagingProduct) issue('packaging_product');
        if (record.role === 'sample') {
          if (!Number.isInteger(item.quantity) || item.quantity < 1) issue('sample_quantity');
          else group.sampleCount += item.quantity;
          if (record.packagingProduct) issue('sample_product');
          // Every configured sample must remain a native child of this exact packaging line.
          if (!item.parent_relationship || !parent || parentKey(item) !== parent.key) issue('parent_link');
        }
      });
      if (group.expectedCount !== group.sampleCount) issue('sample_count');
      group.valid = group.issues.length === 0;
      return group;
    });

    return {
      groups: result,
      related: related,
      hasGiftboxes: result.length > 0,
      valid: result.every(function (group) { return group.valid; })
    };
  }

  function install(win) {
    var doc = win.document;
    var configNode = doc.getElementById('MirjoGiftboxCartConfig');
    if (!configNode || win.MirjoGiftboxCart) return;
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
    var strings = config.strings || {};
    var options = { packagingProductId: config.packagingProductId, packagingVariantId: config.packagingVariantId };
    var cart = config.cart || { items: [] };
    var model = validateCart(cart, options);
    var refreshTimer;
    var refreshPromise;
    var refreshAgain = false;
    var pendingRefresh = false;
    var refreshVersion = 0;
    var heldInvalidation = false;
    var checking = false;
    var removing = false;
    var requestError = '';
    var permittedForms = new WeakSet();
    var cartUrl = config.cartUrl || '/cart';
    var owned = 'data-mirjo-giftbox-owned';

    function text(key, values) {
      var value = strings[key] || key;
      Object.keys(values || {}).forEach(function (name) {
        value = value.split('__' + name.toUpperCase() + '__').join(String(values[name]));
      });
      return value;
    }

    function element(tag, className, content) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (content !== undefined) node.textContent = content;
      return node;
    }

    function productUrl() {
      var url = new URL(config.productUrl || '/products/mirjo-duft-geschenkbox', win.location.origin);
      return url.pathname + url.search;
    }

    function setDisabled(node, active) {
      if (active) {
        if (!node.hasAttribute('data-mirjo-giftbox-disabled')) {
          node.setAttribute('data-mirjo-giftbox-disabled', node.disabled ? '1' : '0');
        }
        node.disabled = true;
      } else if (node.hasAttribute('data-mirjo-giftbox-disabled')) {
        node.disabled = node.getAttribute('data-mirjo-giftbox-disabled') === '1';
        node.removeAttribute('data-mirjo-giftbox-disabled');
      }
    }

    function lockRows() {
      var groupsByIndex = new Map();
      model.groups.forEach(function (group) {
        group.records.forEach(function (record) { groupsByIndex.set(record.index + 1, group); });
      });
      doc.querySelectorAll('.cart-item[id]').forEach(function (row) {
        var match = row.id.match(/^(?:CartItem|CartDrawer-Item)-(\d+)$/);
        if (!match) return;
        var group = groupsByIndex.get(Number(match[1]));
        row.classList.toggle('mirjo-giftbox-cart-line', !!group);
        if (group) row.setAttribute('data-mirjo-giftbox-line', group.id);
        else row.removeAttribute('data-mirjo-giftbox-line');
        row.querySelectorAll('quantity-input button, cart-remove-button button').forEach(function (node) { setDisabled(node, !!group); });
        row.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
          if (group) {
            if (!input.hasAttribute('data-mirjo-giftbox-readonly')) {
              input.setAttribute('data-mirjo-giftbox-readonly', input.readOnly ? '1' : '0');
            }
            // Keep the quantity in native form submissions; disabling it would shift updates[].
            input.readOnly = true;
            input.setAttribute('aria-readonly', 'true');
          } else if (input.hasAttribute('data-mirjo-giftbox-readonly')) {
            input.readOnly = input.getAttribute('data-mirjo-giftbox-readonly') === '1';
            input.removeAttribute('aria-readonly');
            input.removeAttribute('data-mirjo-giftbox-readonly');
          }
        });
        var note = row.querySelector('[data-mirjo-giftbox-line-note]');
        if (!group) { if (note) note.remove(); return; }
        var label = text('lineNote', { number: group.number });
        if (!note) {
          note = element('p', 'mirjo-giftbox-cart-line-note', label);
          note.setAttribute('data-mirjo-giftbox-line-note', '');
          note.setAttribute(owned, '');
          var details = row.querySelector('.cart-item__details');
          if (details) details.appendChild(note);
        } else if (note.textContent !== label) note.textContent = label;
      });
    }

    function renderSummary(host) {
      var summary = host.querySelector('[data-mirjo-giftbox-summary]');
      if (!model.hasGiftboxes && !heldInvalidation && !requestError) { if (summary) summary.remove(); return; }
      var signature = JSON.stringify({ groups: model.groups.map(function (group) {
        return [group.id, group.valid, group.expectedCount, group.sampleCount];
      }), checking: checking, pending: pendingRefresh, removing: removing, error: requestError });
      if (summary && summary.getAttribute('data-signature') === signature) return;
      var next = element('section', 'mirjo-giftbox-cart-summary');
      next.setAttribute('data-mirjo-giftbox-summary', '');
      next.setAttribute(owned, '');
      next.setAttribute('data-signature', signature);
      next.setAttribute('aria-label', text('title'));
      next.tabIndex = -1;
      model.groups.forEach(function (group) {
        var card = element('div', 'mirjo-giftbox-cart-card');
        card.appendChild(element('h3', 'h5', text('groupTitle', { number: group.number })));
        card.appendChild(element('p', '', group.expectedCount
          ? text('summary', { count: group.expectedCount })
          : text('selection', { count: group.sampleCount })));
        if (!group.valid) {
          var warning = element('p', 'mirjo-giftbox-cart-warning', text('invalid'));
          warning.setAttribute('role', 'alert');
          card.appendChild(warning);
        }
        var actions = element('div', 'mirjo-giftbox-cart-actions');
        if (group.valid) {
          var add = element('a', 'link underlined-link', text('addAnother'));
          add.href = productUrl();
          actions.appendChild(add);
        }
        var remove = element('button', 'link underlined-link', text(group.valid ? 'remove' : 'restart'));
        remove.type = 'button';
        remove.setAttribute('data-mirjo-giftbox-remove', group.id);
        if (!group.valid) remove.setAttribute('data-mirjo-giftbox-restart', '');
        remove.disabled = checking || removing;
        actions.appendChild(remove);
        card.appendChild(actions);
        next.appendChild(card);
      });
      if (checking || pendingRefresh || removing || requestError) {
        var status = element('p', 'mirjo-giftbox-cart-status', requestError || text(removing ? 'removing' : 'checking'));
        status.setAttribute('role', requestError ? 'alert' : 'status');
        next.appendChild(status);
      }
      if (host.querySelector('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, shopify-accelerated-checkout-cart')) {
        next.appendChild(element('p', 'mirjo-giftbox-cart-express-note', text('expressNote')));
      }
      if (summary) summary.replaceWith(next);
      else host.prepend(next);
    }

    function render() {
      lockRows();
      doc.querySelectorAll('#main-cart-footer .cart__blocks, cart-drawer .drawer__footer').forEach(renderSummary);
      var blocked = pendingRefresh || !!requestError || (model.hasGiftboxes && (!model.valid || checking || removing));
      doc.querySelectorAll('#checkout, #CartDrawer-Checkout, .cart__checkout-button').forEach(function (node) { setDisabled(node, blocked); });
      // Express buttons can live in cross-origin frames. Use normal checkout for checked gift boxes.
      doc.querySelectorAll('#main-cart-footer .additional-checkout-buttons, #main-cart-footer .cart__dynamic-checkout-buttons, #main-cart-footer shopify-accelerated-checkout-cart, cart-drawer .additional-checkout-buttons, cart-drawer shopify-accelerated-checkout-cart').forEach(function (node) {
        if (model.hasGiftboxes || pendingRefresh || heldInvalidation || requestError) {
          if (!node.hasAttribute('data-mirjo-giftbox-hidden')) node.setAttribute('data-mirjo-giftbox-hidden', node.hidden ? '1' : '0');
          node.hidden = true;
        } else if (node.hasAttribute('data-mirjo-giftbox-hidden')) {
          node.hidden = node.getAttribute('data-mirjo-giftbox-hidden') === '1';
          node.removeAttribute('data-mirjo-giftbox-hidden');
        }
      });
    }

    function focusNotice() {
      var drawer = doc.querySelector('cart-drawer.active [data-mirjo-giftbox-summary]');
      var notice = drawer || doc.querySelector('[data-mirjo-giftbox-summary]');
      if (notice) notice.focus();
    }

    async function readCart() {
      var response = await win.fetch(cartUrl.replace(/\/$/, '') + '.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('cart_unavailable');
      var state = await response.json();
      if (!state || !Array.isArray(state.items)) throw new Error('invalid_cart_response');
      return state;
    }

    function acceptCart(state, version, releaseInvalidation) {
      if (version !== undefined && version !== refreshVersion) return model;
      cart = state;
      model = validateCart(cart, options);
      if (!heldInvalidation || releaseInvalidation) {
        heldInvalidation = false;
        requestError = '';
        pendingRefresh = false;
      }
      render();
      return model;
    }

    function scheduleRead() {
      win.clearTimeout(refreshTimer);
      refreshTimer = win.setTimeout(function () { refresh(false).catch(function () {}); }, 350);
    }

    function refresh(releaseInvalidation) {
      if (refreshPromise) {
        if (releaseInvalidation) return refreshPromise.catch(function () {}).then(function () { return refresh(true); });
        return refreshPromise;
      }
      win.clearTimeout(refreshTimer);
      var version = refreshVersion;
      refreshPromise = readCart().then(function (state) {
        if (version !== refreshVersion) { refreshAgain = true; return model; }
        return acceptCart(state, version, releaseInvalidation);
      }).catch(function (error) {
        if (version === refreshVersion && (model.hasGiftboxes || pendingRefresh || heldInvalidation)) {
          requestError = text('checkError');
          render();
        }
        throw error;
      }).finally(function () {
        refreshPromise = null;
        if (refreshAgain) { refreshAgain = false; scheduleRead(); }
      });
      var currentRead = refreshPromise;
      if (releaseInvalidation) return currentRead.then(function (result) {
        return version === refreshVersion && !heldInvalidation ? result : refresh(true);
      });
      return currentRead;
    }

    function invalidate() {
      refreshVersion += 1;
      heldInvalidation = true;
      pendingRefresh = true;
      requestError = '';
      win.clearTimeout(refreshTimer);
      render();
    }

    function queueRefresh() {
      refreshVersion += 1;
      pendingRefresh = true;
      render();
      scheduleRead();
    }

    function replayForm(form, submitter) {
      permittedForms.add(form);
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
        else {
          var marker = element('input');
          marker.type = 'hidden';
          marker.name = 'checkout';
          form.appendChild(marker);
          win.HTMLFormElement.prototype.submit.call(form);
        }
      } finally {
        win.setTimeout(function () { permittedForms.delete(form); }, 0);
      }
    }

    async function checkAndContinue(continuation) {
      if (checking || removing) return;
      if (heldInvalidation) { render(); focusNotice(); return; }
      var shouldFocus = false;
      var version = refreshVersion;
      checking = true;
      requestError = '';
      render();
      try {
        // Do not reuse a queued read: a just-finished cart mutation must be visible here.
        var state = await readCart();
        if (version !== refreshVersion || heldInvalidation) { shouldFocus = true; return; }
        acceptCart(state, version, false);
        if (!model.valid) { shouldFocus = true; return; }
        checking = false;
        render();
        continuation();
      } catch (error) {
        requestError = text('checkError');
        shouldFocus = true;
      } finally {
        checking = false;
        render();
        if (shouldFocus) focusNotice();
      }
    }

    async function changeCart(endpoint, body) {
      var response = await win.fetch(cartUrl.replace(/\/$/, '') + '/' + endpoint + '.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var result = await response.json();
      if (!response.ok || result.errors || result.status >= 400) throw new Error('cart_change_failed');
      return result;
    }

    async function removeGroup(id, restart) {
      if (checking || removing) return;
      removing = true;
      requestError = '';
      render();
      try {
        var state = await readCart();
        var current = validateCart(state, options).groups.find(function (group) { return group.id === id; });
        if (!current) {
          acceptCart(state);
          if (restart) win.location.assign(productUrl());
          else win.location.reload();
          return;
        }
        var originalKeys = new Set(current.records.map(function (record) { return record.item.key; }));
        var parents = current.records.filter(function (record) { return record.role === 'packaging' || record.packagingProduct; });
        // Removing a native parent also removes its nested children.
        for (var index = 0; index < parents.length; index++) {
          var key = parents[index].item.key;
          if (state.items.some(function (item) { return item.key === key; })) state = await changeCart('change', { id: key, quantity: 0 });
        }
        // Explicit removal also cleans unlinked lines of an already incomplete group.
        var updates = {};
        state.items.forEach(function (item) {
          if (originalKeys.has(item.key) || (current.value && groupValue(item) === current.value)) updates[item.key] = 0;
        });
        if (Object.keys(updates).length) state = await changeCart('update', { updates: updates });
        acceptCart(state);
        if (restart) win.location.assign(productUrl());
        else win.location.reload();
      } catch (error) {
        try { acceptCart(await readCart()); } catch (ignored) {}
        requestError = text('removeError');
      } finally {
        removing = false;
        render();
        if (requestError) focusNotice();
      }
    }

    doc.addEventListener('click', function (event) {
      var target = event.target instanceof win.Element ? event.target : event.target.parentElement;
      if (!target) return;
      var remove = target.closest('[data-mirjo-giftbox-remove]');
      if (remove) {
        event.preventDefault();
        event.stopImmediatePropagation();
        removeGroup(remove.getAttribute('data-mirjo-giftbox-remove'), remove.hasAttribute('data-mirjo-giftbox-restart'));
        return;
      }
      if (target.closest('[data-mirjo-giftbox-line] quantity-input, [data-mirjo-giftbox-line] cart-remove-button')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!model.hasGiftboxes && !pendingRefresh) return;
      var button = target.closest('[name="checkout"], .cart__checkout-button');
      var link = target.closest('a[href]');
      var checkoutLink = false;
      if (link) {
        var url = new URL(link.href, win.location.origin);
        checkoutLink = url.origin === win.location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname);
      }
      if (!button && !checkoutLink) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button) {
        var form = button.form || doc.getElementById(button.getAttribute('form'));
        if (form) checkAndContinue(function () { replayForm(form, button); });
      } else checkAndContinue(function () { win.location.assign(link.href); });
    }, true);

    doc.addEventListener('submit', function (event) {
      var form = event.target;
      if (permittedForms.has(form)) { permittedForms.delete(form); return; }
      if ((!model.hasGiftboxes && !pendingRefresh) || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkAndContinue(function () { replayForm(form, event.submitter); });
    }, true);

    function ownedMutation(mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target && target.closest('[' + owned + ']')) return true;
      var changed = Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes));
      return changed.length > 0 && changed.every(function (node) { return node.nodeType === 1 && node.hasAttribute(owned); });
    }

    var observer = new win.MutationObserver(function (mutations) {
      var cartChanged = mutations.some(function (mutation) {
        if (ownedMutation(mutation)) return false;
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        if (target && target.closest('#main-cart-items, #main-cart-footer, cart-drawer')) return true;
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('cart-drawer, #main-cart-items, #main-cart-footer') || node.querySelector('cart-drawer, #main-cart-items, #main-cart-footer'));
        });
      });
      if (cartChanged) { render(); queueRefresh(); }
    });
    observer.observe(doc.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, queueRefresh);
    }
    doc.addEventListener('mirjo:giftbox:cart-updated', queueRefresh);
    win.addEventListener('pageshow', function (event) { if (event.persisted) queueRefresh(); });
    win.MirjoGiftboxCart = {
      invalidate: invalidate,
      refresh: function () { return refresh(true); },
      validate: function () { return validateCart(cart, options); }
    };
    render();
  }

  return { validateCart: validateCart, install: install };
});
